module.exports = __webpack_public_path__ + "static/media/PDF_108.25e762fd.pdf";